export const isAuthenticated = (): boolean => {
  const admin = localStorage.getItem('admin');
  return !!admin;
};

export const getStoredAdmin = () => {
  const admin = localStorage.getItem('admin');
  if (admin) {
    try {
      return JSON.parse(admin);
    } catch {
      return null;
    }
  }
  return null;
};

export const setStoredAdmin = (admin: any): void => {
  localStorage.setItem('admin', JSON.stringify(admin));
};

export const storeRegions = (admin: any): void => {
  localStorage.setItem('regions', JSON.stringify(admin));
};

export const getStoredRegions = () => {
  const regions = localStorage.getItem('regions');
  if (regions) {
    try {
      return JSON.parse(regions);
    } catch {
      return null;
    }
  }
  return null;
};

export const storeDistricts = (admin: any): void => {
  localStorage.setItem('districts', JSON.stringify(admin));
};

export const getStoredDistricts = () => {
  const districts = localStorage.getItem('districts');
  if (districts) {
    try {
      return JSON.parse(districts);
    } catch {
      return null;
    }
  }
  return null;
};

export const storeOwners = (admin: any): void => {
  localStorage.setItem('owners', JSON.stringify(admin));
};

export const getStoredOwners = () => {
  const owners = localStorage.getItem('owners');
  if (owners) {
    try {
      return JSON.parse(owners);
    } catch {
      return null;
    }
  }
  return null;
};

export const storeAmenities = (admin: any): void => {
  localStorage.setItem('ameniities', JSON.stringify(admin));
};

export const getStoredAmenities = () => {
  const ameniities = localStorage.getItem('ameniities');
  if (ameniities) {
    try {
      return JSON.parse(ameniities);
    } catch {
      return null;
    }
  }
  return null;
};

export const clearStoredAuth = (): void => {
  localStorage.removeItem('admin');
  localStorage.removeItem('regions');
  localStorage.removeItem('districts');
  localStorage.removeItem('owners');
  localStorage.removeItem('ameniities');
  localStorage.removeItem('authToken');
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminEmail');
  localStorage.removeItem('adminId');
};

export const logout = (): void => {
  clearStoredAuth();
};
